module.exports = __webpack_public_path__ + "fonts/xjAJXh38I15wypJXxuGMBlBW26QxpSj-_ZKm_xT4hWw.woff2";